import React from 'react';
import { NavItem } from 'reactstrap';
import { StyledNav, StyledNavLink, StyledPolicyIcon } from './styledPolicyTabs';

interface IPolicyTabsProps {
  tabs: {
    policyType: string;
    policyTitle: string;
  }[];
  activeTab?: string;
  onClick: (...args: any[]) => any;
  className?: string;
}

const PolicyTabs = ({ tabs, activeTab, onClick, className }: IPolicyTabsProps): JSX.Element => {
  const handleClick = (policyVersion: any) => () => onClick(policyVersion);

  return (
    <StyledNav className={className}>
      {tabs.map(({ policyVersion, policyType, policyTitle }: any) => (
        <NavItem key={policyVersion} data-test-id="PolicyTabs-item">
          <StyledNavLink
            href="#"
            active={activeTab === policyVersion}
            onClick={handleClick(policyVersion)}
            data-test-id="PolicyTabs-link"
            data-analytics={`policyTabs${policyType}`}
          >
            <StyledPolicyIcon type={policyType} />
            {policyTitle}
          </StyledNavLink>
        </NavItem>
      ))}
    </StyledNav>
  );
};

export default PolicyTabs;
